/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */


import { FormControlLabel } from '@mui/material';
import { useField } from 'formik';
import {
  CheckboxField,
  ColorPicker,
  EditInPlaceField,
  EditInPlaceFileField,
  EditInPlaceSearchSelect,
  FormFieldProps
} from 'ish-ui';
// Formik adapter for ish-ui fields
import React, { useMemo } from 'react';

const FormField = ({ type, name, ...props }: FormFieldProps & { name: string, label?: React.ReactNode }) => {
  const [{ onBlur, ...input }, meta, { setValue }] = useField(name);

  const inputProxy = useMemo(() => ({
    ...input || {},
    onChange: async e => {
      const val = e?.target ? e.target.value : e;
      await setValue(val);
    },
    onBlur: async e => {
      const val = e?.target ? e.target.value : e;
      await setValue(val);
    },
  }), [input]);

  const sharedProps = {
    ...props,
    input: inputProxy,
    meta: {
      invalid: Boolean(meta.error),
      error: meta.error
    },
    placeholder: (props as any).placeholder || 'No value'
  };


  switch (type) {
    default:
    case 'text':
    case 'number':
    case 'multilineText':
      return <EditInPlaceField {...sharedProps} />;
    case "select":
      return <EditInPlaceSearchSelect {...sharedProps} />
    case 'file':
      return <EditInPlaceFileField {...sharedProps} />;
    case 'color':
      return <ColorPicker {...sharedProps} />;
    case 'checkbox':
      return <FormControlLabel
        className={(props as any).className}
        control={
          <CheckboxField
            {...sharedProps as any}
            color="primary"
          />
        }
        label={(props as any).label}
      />
  }
};

export default FormField;